import axios from 'axios';

export const checkOutOfStockProducts = async (productIds) => {
  if (!productIds?.length) {
    return {
      outOfStock: [],
      inStock: [],
      error: null
    };
  }

  try {
    const responses = await Promise.allSettled(
      productIds.map(id =>
        axios.get(`${process.env.REACT_APP_BASE_URL}/products/get/${id}`)
      )
    );

    const result = {
      outOfStock: [],
      inStock: [],
      error: null
    };

    responses.forEach((res, idx) => {
        const id = productIds[idx];
      
        if (res.status !== 'fulfilled') {
          result.outOfStock.push(id);
          console.log(`API failed for product: ${id}`);
          return;
        }
      
        const product = res.value.data?.data; // ✅ FIX
      
        console.log("Product Data:", product);
      
        const stocksArray = product?.stock?.stocks;
      
        if (!Array.isArray(stocksArray)) {
          console.log(`Invalid or missing stocks array for product: ${product?._id}`);
          result.outOfStock.push(product?._id || id);
          return;
        }
      
        const totalStock = stocksArray.reduce(
          (total, stockItem) => total + (stockItem?.quantity || 0),
          0
        );
      
        console.log(`Total stock for ${product._id}:`, totalStock);
      
        if (totalStock <= 0) {
          result.outOfStock.push(product._id);
        } else {
          result.inStock.push(product._id);
        }
      });
      
      

    return result;
  } catch (error) {
    // Yeh catch tab chalega jab `Promise.allSettled` se pehle hi kuch crash ho jaaye
    return {
      outOfStock: [...productIds],
      inStock: [],
      error: error?.message || 'Failed to check stock status'
    };
  }
};
